<template>
  <div id="app">
    <Navbar />
    <main class="main-content">
      <router-view/>
    </main>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer/index.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  watch: {
    $route() {
      // 路由变化时滚动到页面顶部
      window.scrollTo(0, 0);
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  min-height: 100vh;
}

.main-content {
  margin-top: 80px;
  min-height: calc(100vh - 80px);
}
</style>
